import { createStyles, keyframes } from '@mantine/core';
keyframes({
  "from, to": {
    opacity: 1
  },
  "50%": {
    opacity: 0.8
  }
});
var useStyles = createStyles(function (_theme, _ref) {
  var backgroundColor = _ref.backgroundColor,
    _ref$jumpLineWidth = _ref.jumpLineWidth,
    jumpLineWidth = _ref$jumpLineWidth === void 0 ? 4 : _ref$jumpLineWidth;
  return {
    root: {
      pointerEvents: "none",
      shapeRendering: "auto"
    },
    background: {
      fill: backgroundColor,
      pointerEvents: "auto"
    },
    systemName: {
      filter: "drop-shadow(0px 0px 0.05em #000) drop-shadow(0px 0px 5px #000)",
      fill: "#FFFFFF",
      fontSize: 100,
      dominantBaseline: "middle"
    },
    jumpLines: {
      strokeWidth: jumpLineWidth,
      stroke: "#FFFFFF",
      strokeOpacity: 0.3
    }
  };
});
export { useStyles as default };